import { Component, Input, OnInit } from '@angular/core';
import { EventMappingType } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { EventsService } from 'src/app/services/events.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { UtilityService } from 'src/app/services/util/utility.service';
import { Subscription } from 'rxjs';
import { CacheService } from 'src/app/services/cache.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { StorageService } from 'src/app/services/util/storage.service';
import { SportsService } from 'src/app/services/sports.service';

@Component({
  selector: 'app-search-events',
  templateUrl: './search-events.component.html',
  styleUrls: ['./search-events.component.less']
})
export class SearchEventsComponent implements OnInit {
  public searchValue = '';
  // searchPlaceholder = DynamicTranslations.searchForMatch_placeholder;
  pageId: number;
  events: EventVM[] = [];
  isSearchValid: boolean;
  isSearchFocus = false;
  public searchMessage = '';
  eventMappingTypeEnum = EventMappingType;
  private timeout;
  favoriteLeaguesIsExpanded = false;
  showFavoriteOption = false;

  isMobileView = false;

  dynamicTranslations = DynamicTranslations;

  private subscription: Subscription = new Subscription();

  @Input()
  isLive = false;

  viewConfigurations = ViewConfigurations;

  constructor(private eventsService: EventsService, private sportsService: SportsService, protected storage: StorageService, private utilityService: UtilityService, private cache: CacheService) {
    this.isMobileView = this.utilityService.mobileView;
  }

  ngOnInit(): void {
    this.subscription.add(this.sportsService.favoriteCompetitionSRCChanged$.subscribe(s => {
      this.addRemoveCompetitionToFavoritesFromService(s);
    }));
    this.showFavoriteOption = this.viewConfigurations.isFavoriteEventsEnabled;
  }

  search() {
    clearTimeout(this.timeout);
    this.setIsSearchValid();
    if (!this.isSearchValid) {
      return;
    }


    this.searchValue = this.searchValue.trim();
    if (!this.isLive) {
      this.timeout = setTimeout(() => {
        this.getResultFromServer();
      }, 500);
    } else {
      this.events = this.cache.searchForEvents(this.searchValue);
      this.setSearchMessageAfterSearch();
    }
  }

  addRemoveCompetitionToFavoritesFromService(s) {
    if (this.events) {
      this.events.map(ev => {
        if (ev.competitionId === s.competitionId) {
          ev.isCompetiionInFavorite = !ev.isCompetiionInFavorite;
        }
        return ev;
      });
    }
  }

  getResultFromServer() {
    this.eventsService.getEventsForSearch(this.searchValue).subscribe(events => {
      this.events = events;
      this.setSearchMessageAfterSearch();
      this.events.forEach(e => {
        const exist = this.sportsService.favoriteCompetitions.find(c => c.id === e.competitionId);
        if (exist) {
          e.isCompetiionInFavorite = true;
        }
        else {
          e.isCompetiionInFavorite = false;
        }
      });
    });
  }

  private setSearchMessageAfterSearch() {
    if (this.events.length === 0) {
      this.searchMessage = DynamicTranslations.searchForMatch_noResults;
    } else {
      this.searchMessage = '';
      this.isSearchFocus = true;
    }
  }

  setIsSearchValid() {
    const validation = this.utilityService.isSearchValid(this.searchValue);
    this.isSearchValid = validation.isSearchValid;
    this.searchMessage = validation.searchMessage;
    this.searchValue = validation.searchValue;
    if (!this.isSearchValid) {
      this.events = [];
    }
  }

  clearList() {
    this.events = [];
  }

  clearSearchMsg() {
    this.isSearchValid = false;
    this.searchMessage = '';
    // console.log('aut');

    setTimeout(() => {
      this.isSearchFocus = false;
    }, 200);
  }


  clearSearch() {
    this.searchValue = '';
    this.isSearchValid = false;
    this.events = [];
  }

  selectEvent(selectedEvent: EventVM) {
    this.eventsService.expandEvent(selectedEvent);
    this.clearSearch();
  }

  addRemoveCompetitionToFavorites(event: EventVM) {
    const competitionTemp: ICompetition = {
      id: event.competitionId,
      eventsCount: 2,
      name: event.competitionName,
      sportId: event.sportId,
      regionId: event.regionId,
      shortName: null,
      events: [],
      sportName: event.sportName,
      regionName: event.regionName,
      isSelected: false,
      isExpanded: false,
      isShown: false,
      isInFavorites: event.isCompetiionInFavorite,
      orderNo: 2
    };
    // event.isCompetiionInFavorite = !event.isCompetiionInFavorite;
    this.sportsService.addRemoveCompetitionToFavorites(competitionTemp, event);
    // this.storage.favoriteCompetitions= [];
    // const favCmps = this.storage.favoriteCompetitions;
    // favCmps.push(competitionTemp);
    // this.storage.favoriteCompetitions = favCmps;
    // const favCompetitionInd = this.favoriteCompetitions.findIndex(c => c.id === competition.id);
    // if (competition.isInFavorites) {
    //   competition.isInFavorites = false;
    //   if (favCompetitionInd < 0) {
    //     return;
    //   }

    //   this.favoriteCompetitions.splice(favCompetitionInd, 1);
    //   this.storage.favoriteCompetitions = this.favoriteCompetitions;
    //   if (this.favoriteCompetitions.findIndex(c => c.eventsCount > 0) < 0) {
    //    // this.favoriteCompetitionsHaveOnlineEvents = false;
    //   }
    // } else {

    //   if (favCompetitionInd < 0) {
    //     this.favoriteCompetitions.push(competition);
    //   }
    //   if (competition.eventsCount > 0) {
    //     //this.favoriteCompetitionsHaveOnlineEvents = true;
    //   }
    //   this.storage.favoriteCompetitions = this.favoriteCompetitions;
    //   competition.isInFavorites = true;
    // }
  }

  toogleFavorites(event: EventVM){
    this.eventsService.toggleFavorites(event);
  }


}
